(function () {
  function initPeekSlider(root) {
    if (root.hasAttribute('data-peek-ready')) return;

    const scroller = root.querySelector('[data-peek-scroller]');
    const prev = root.querySelector('[data-peek-prev]');
    const next = root.querySelector('[data-peek-next]');

    if (!scroller) return;

    root.setAttribute('data-peek-ready', '');

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const left = scroller.scrollLeft;
      const scrollable = max > 4;

      root.classList.toggle('peek-slider--scrollable', scrollable);
      root.classList.toggle('peek-slider--at-start', left <= 4);
      root.classList.toggle('peek-slider--at-end', left >= max - 4);
    };

    const scrollByDirection = (direction) => {
      const item = scroller.querySelector('[data-peek-item]') || scroller.children[0];
      const styles = item ? window.getComputedStyle(item.parentElement || item) : null;
      const gap = styles ? parseFloat(styles.columnGap || styles.gap) || 0 : 0;
      const amount = item ? item.getBoundingClientRect().width + gap : scroller.clientWidth * 0.7;

      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    if (prev) {
      prev.addEventListener('click', () => scrollByDirection(-1));
    }

    if (next) {
      next.addEventListener('click', () => scrollByDirection(1));
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-peek-slider]').forEach(initPeekSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
